import $ from 'jquery';

// jQuery must exist as a browser global before any jQuery plugin (jquery-ui,
// velocity-animate) is evaluated. ES modules evaluate an imported module before the
// importing module's own (later) side-effect imports, so importing this module first
// guarantees the global is in place in time.
//
// Under the old CRA/webpack build this was a runtime `require(...)` ordered after the
// assignment; ESM hoists `import` statements above the module body, so the assignment
// has to live in a separately-imported module instead.
(globalThis as unknown as Record<string, unknown>).$ = $;
(globalThis as unknown as Record<string, unknown>).jQuery = $;

export default $;
